import { createContext, useState, useEffect } from 'react';
import AuthService, {isAuthenticated} from '../services/AuthService';
import LogUtils from '../utils/LogUtils';

export const AuthContext = createContext();

const authService = new AuthService();

function AuthContextProvider(props) {
  const TAG = "AuthContextProvider";

  const [isAuthorized, setIsAuthorized] = useState(true);
  const [authUser, setAuthUser] = useState(authService.getCurrentUser());
  const logUtils = new LogUtils();

  useEffect(() => {
    setIsAuthorized(isAuthenticated() && authUser);

    async function checkLogin() {
      const resIsLoggedIn = await authService.updateIsAuthenticatedStatus()
    
      if (!resIsLoggedIn) {
        setIsAuthorized(false);
        return;
      }
      setTimeout(checkLogin, 60000 * 1);
    }
    checkLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function login({email, password}) {
    const resLogin = await authService.login(email, password);

    if (resLogin.status !== 1 || !resLogin.data) {
      logUtils.logErrorMsg(TAG, "Failed to login", resLogin.msg);
      setAuthUser(null);
      setIsAuthorized(false);
      return {
        success: false,
        msg: resLogin.msg
      };
    }
    setAuthUser(resLogin.data);
    setIsAuthorized(true);
    return {
      success: true
    };
  }

  async function refreshCurrentUser() {
    const resRefresh = await authService.refreshUser(authUser?.user?.email);

    if (resRefresh.status !== 1 || !resRefresh.data) {
      setAuthUser(null);
      setIsAuthorized(false);
      return false;
    }
    setAuthUser(resRefresh.data);
    setIsAuthorized(true);
    return true;
  }

  async function logout() {
    const resLogout = await authService.logout();

    if (resLogout.status !== 1) {
      logUtils.logErrorMsg(TAG, "Failed to logout", resLogout.msg);
      return false;
    }
    setIsAuthorized(false);
    return true;
  }

  async function rememberPassword({email}) {
    const resRememberPassword = await authService.sendInstructionsToRecoverPassword(email);

    if (resRememberPassword.status !== 1) {
      logUtils.logErrorMsg(TAG, "Failed to rememberPassword", resRememberPassword.msg);
      return {
        success: false,
        msg: resRememberPassword.msg
      };
    }
    return {
      success: true
    };
  }

  async function redefinePassword({email, code, password}) {
    const resResetPassword = await authService.resetPassword(email, code, password);

    if (resResetPassword.status !== 1) {
      logUtils.logErrorMsg(TAG, "Failed to redefinePassword", resResetPassword.msg);
      return {
        success: false,
        msg: resResetPassword.msg
      };
    }
    return {
      success: true
    };
  }

  return (
    <AuthContext.Provider value={{
      authUser,
      isAuthorized,
      login,
      logout,
      redefinePassword,
      refreshCurrentUser,
      rememberPassword
    }}>
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContextProvider;
